/* Dormille — interactions */
(function () {
  'use strict';

  /* ---- menu mobile ---- */
  var nav = document.querySelector('[data-mobile-nav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-open]'))  { nav && nav.classList.add('is-open'); }
    if (e.target.closest('[data-mobile-close]')) { nav && nav.classList.remove('is-open'); }
  });

  /* ---- fermeture des menus deroulants au clic exterieur ---- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-nav-dropdown][open]').forEach(function (d) {
      if (!d.contains(e.target)) { d.removeAttribute('open'); }
    });
  });

  /* ---- selecteur de paliers (page produit) ---- */
  var packForm = document.getElementById('pack-form');
  if (packForm) {
    var priceEl  = document.querySelector('[data-atc-price]');
    var stickyEl = document.querySelector('[data-sticky-price]');
    var labelEl  = document.querySelector('[data-sticky-label]');
    var cards    = Array.prototype.slice.call(packForm.querySelectorAll('[data-pack-card]'));

    function syncPacks() {
      var selected = null;

      cards.forEach(function (card) {
        var input = card.querySelector('[data-pack-input]');
        var on    = !!(input && input.checked);
        card.classList.toggle('is-selected', on);
        if (on) { selected = card; }

        // Seul le palier selectionne envoie ses proprietes de ligne. Desactiver ne
        // suffit pas : le paiement accelere (PayPal, Shop Pay) lit aussi les champs
        // desactives. Sans nom, un champ n est envoye par personne.
        var extra = card.querySelector('[data-pack-extra]');
        if (extra) {
          extra.querySelectorAll('[data-prop]').forEach(function (field) {
            field.disabled = !on;
            if (on) { field.name = field.getAttribute('data-prop'); }
            else    { field.removeAttribute('name'); }
          });
        }
      });

      if (!selected) return;

      var price = selected.getAttribute('data-price');
      var label = selected.getAttribute('data-sticky') || selected.getAttribute('data-label');
      if (priceEl && price)  { priceEl.textContent  = price; }
      if (stickyEl && price) { stickyEl.textContent = price; }
      if (labelEl && label)  { labelEl.textContent  = label; }
    }

    packForm.addEventListener('change', function (e) {
      if (e.target.closest('[data-pack-input]')) { syncPacks(); }

      // Etat visuel des choix de housse (taille et motif).
      var opt = e.target.closest('.chooser__opt');
      if (opt && e.target.type === 'radio') {
        var group = e.target.name;
        packForm.querySelectorAll('.chooser__opt').forEach(function (o) {
          var r = o.querySelector('input[type=radio]');
          if (r && r.name === group) { o.classList.toggle('is-on', r.checked); }
        });
      }
    });

    /* ---- compteurs par tranche d age : le total choisit le palier ----
       Un seul etat pour toutes les cartes (les tailles, une entree par oreiller).
       Tout a zero a l arrivee : c est au parent de choisir (demande de Zak, 28/10).
       Chaque carte affiche cet etat ; ses champs caches recoivent une taille par
       oreiller, dans l ordre des tranches. Tant qu il manque une taille pour le
       palier coche, l ajout au panier est bloque et le paiement accelere masque. */
    var counters = packForm.querySelector('[data-age-counter]');
    if (counters) {
      var ordre = Array.prototype.map.call(counters.querySelectorAll('[data-age]'), function (r) {
        return r.getAttribute('data-age');
      });
      var maxQty = 0;
      cards.forEach(function (c) { maxQty = Math.max(maxQty, +c.getAttribute('data-qty') || 0); });

      var tailles = [];
      var derniere = null;
      var alerte = false;

      function compte(age) {
        return tailles.filter(function (t) { return t === age; }).length;
      }

      function carteChoisie() {
        return packForm.querySelector('[data-pack-card].is-selected') || cards[0];
      }

      function qtyChoisie() {
        return +carteChoisie().getAttribute('data-qty') || 1;
      }

      function manque() {
        return Math.max(qtyChoisie() - tailles.length, 0);
      }

      function texteAlerte() {
        var n = manque();
        if (n === 0) return '';
        if (tailles.length === 0 && qtyChoisie() === 1) return 'Choisissez sa tranche d\u2019\u00e2ge avec le bouton +.';
        return 'Choisissez encore ' + n + (n > 1 ? ' tranches d\u2019\u00e2ge.' : ' tranche d\u2019\u00e2ge.');
      }

      function afficher() {
        tailles.sort(function (a, b) { return ordre.indexOf(a) - ordre.indexOf(b); });
        var texte = alerte ? texteAlerte() : '';
        packForm.classList.toggle('is-incomplete', manque() > 0);
        packForm.querySelectorAll('[data-age-counter]').forEach(function (bloc) {
          bloc.querySelectorAll('[data-age]').forEach(function (r) {
            var n = compte(r.getAttribute('data-age'));
            r.querySelector('[data-age-n]').textContent = n;
            r.classList.toggle('is-on', n > 0);
            r.querySelector('[data-age-step="-1"]').disabled = n === 0;
            r.querySelector('[data-age-step="1"]').disabled = tailles.length >= maxQty;
          });
          bloc.querySelectorAll('[data-age-field]').forEach(function (f, i) {
            f.value = tailles[i] || '';
          });
          var a = bloc.querySelector('[data-age-alert]');
          if (a) { a.textContent = texte; a.hidden = !texte; }
          bloc.classList.toggle('is-missing', !!texte);
        });
      }

      function carteDe(qty) {
        return cards.filter(function (c) { return +c.getAttribute('data-qty') === qty; })[0];
      }

      packForm.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-age-step]');
        if (!btn) return;
        e.preventDefault();
        var age = btn.closest('[data-age]').getAttribute('data-age');
        var pas = +btn.getAttribute('data-age-step');
        var avant = btn.getBoundingClientRect().top;

        if (pas > 0) { tailles.push(age); derniere = age; }
        else { tailles.splice(tailles.indexOf(age), 1); }

        // En montant, on ne change de palier que si le total le depasse : un parent
        // qui a coche « Le trio » remplit ses 3 tailles sans etre renvoye ailleurs.
        var t = tailles.length;
        var cible = null;
        if ((pas > 0 && t > qtyChoisie()) || (pas < 0 && t >= 1)) { cible = carteDe(t); }
        if (cible) {
          var radio = cible.querySelector('[data-pack-input]');
          if (radio && !radio.checked) { radio.checked = true; syncPacks(); }
        }
        afficher();

        // La carte change : on garde le meme bouton sous le doigt.
        var meme = cible && cible.querySelector('[data-age="' + age + '"] [data-age-step="' + pas + '"]');
        if (meme && meme !== btn) {
          window.scrollBy(0, meme.getBoundingClientRect().top - avant);
          (meme.disabled ? meme.parentNode.querySelector('[data-age-step]:not(:disabled)') || meme : meme).focus();
        }
      });

      // Clic direct sur une carte : on retire les tailles en trop, on n en invente pas.
      packForm.addEventListener('change', function (e) {
        var radio = e.target.closest('[data-pack-input]');
        if (!radio) return;
        var qty = +radio.closest('[data-pack-card]').getAttribute('data-qty') || 1;
        while (tailles.length > qty) {
          var i = tailles.lastIndexOf(derniere);
          tailles.splice(i < 0 ? tailles.length - 1 : i, 1);
        }
        afficher();
      });

      // Ajout au panier (bouton du formulaire ou barre collante) : bloque s il manque
      // une taille. Ecoute sur le formulaire, donc avant le tiroir (sur document).
      packForm.addEventListener('submit', function (e) {
        if (manque() === 0) return;
        e.preventDefault();
        e.stopPropagation();
        alerte = true;
        afficher();
        var bloc = carteChoisie().querySelector('[data-age-counter]');
        if (bloc) {
          bloc.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var plus = bloc.querySelector('[data-age-step="1"]:not(:disabled)');
          if (plus) { plus.focus({ preventScroll: true }); }
        }
      });

      afficher();
    }

    syncPacks();
  }

  /* ---- barre ATC collante : visible des l arrivee (demande de Zak, 28/10) ----
     Elle s efface seulement quand le vrai bouton du formulaire est a l ecran,
     pour ne jamais afficher deux boutons « Ajouter au panier » en meme temps. */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  var mainAtc = anchor && anchor.querySelector('form [type="submit"]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(mainAtc);
  }

  /* ---- galerie en carrousel (fiche oreiller) ----
     Le glissement au doigt est natif (scroll-snap) ; ici : fleches, vignettes,
     clavier, compteur, et suivi de la photo affichee. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-thumb]'));
    var rangee = root.querySelector('[data-carousel-thumbs]');
    var compteur = root.querySelector('[data-carousel-current]');
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var n = slides.length;
    if (n < 2) return;

    function largeur() { return track.clientWidth || 1; }

    /* Prechargement : les photos 2 a n sont en loading=lazy pour ne pas
       ralentir l arrivee sur la page. Sans prechargement, sauter a une photo
       lointaine montrerait un cadre vide le temps qu elle arrive. On les
       charge donc en arriere-plan 3 s apres le chargement, et tout de suite
       au premier geste du visiteur. Le navigateur garde la taille adaptee a
       l ecran (srcset). */
    var precharge = false;
    function precharger() {
      if (precharge) return;
      precharge = true;
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }
    if (document.readyState === 'complete') setTimeout(precharger, 3000);
    else window.addEventListener('load', function () { setTimeout(precharger, 3000); });
    ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach(function (type) {
      root.addEventListener(type, precharger, { once: true, passive: true });
    });

    function marquer(i) {
      index = i;
      if (compteur) compteur.textContent = String(i + 1);
      thumbs.forEach(function (t, k) {
        var actif = k === i;
        t.classList.toggle('is-active', actif);
        if (actif) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      /* recentre la vignette active dans sa rangee, sans faire bouger la page */
      var th = thumbs[i];
      if (th && rangee && rangee.scrollWidth > rangee.clientWidth) {
        var decalage = th.getBoundingClientRect().left - rangee.getBoundingClientRect().left;
        var cible = rangee.scrollLeft + decalage - (rangee.clientWidth - th.offsetWidth) / 2;
        rangee.scrollTo({ left: Math.max(0, cible), behavior: reduit ? 'auto' : 'smooth' });
      }
    }

    /* defilement lance par nous (fleche, vignette, clavier) : tant qu il n est
       pas arrive, le suivi du glissement ne doit pas attraper une photo
       intermediaire. Securite : on relache au bout de 1,5 s quoi qu il arrive. */
    var cible = null;
    var relache = null;

    /* photo de depart pour une fleche ou le clavier : la destination d un
       defilement en cours, sinon la photo REELLEMENT affichee (lue a l ecran,
       jamais une valeur memorisee qui aurait pu rater un glissement). */
    function courant() {
      if (cible !== null) return cible;
      var i = Math.round(track.scrollLeft / largeur());
      return Math.min(Math.max(i, 0), n - 1);
    }

    /* le doigt, la souris ou la molette reprennent la main sur un defilement
       lance par une fleche ou une vignette */
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (type) {
      track.addEventListener(type, function () { cible = null; }, { passive: true });
    });

    function aller(i) {
      var boucle = i < 0 || i >= n;       /* au bout : on repart de l autre cote */
      i = ((i % n) + n) % n;
      cible = i;
      if (relache) clearTimeout(relache);
      relache = setTimeout(function () {
        cible = null;
        var j = courant();
        if (j !== index) marquer(j);
      }, 1500);
      track.scrollTo({ left: i * largeur(), behavior: (boucle || reduit) ? 'auto' : 'smooth' });
      marquer(i);
    }

    /* suit le glissement au doigt ou au pave tactile */
    var attente = null;
    track.addEventListener('scroll', function () {
      if (attente) clearTimeout(attente);
      attente = setTimeout(function () {
        var i = Math.round(track.scrollLeft / largeur());
        if (cible !== null) {
          if (i !== cible) return;         /* encore en route vers la photo demandee */
          cible = null;
        }
        if (i !== index && i >= 0 && i < n) marquer(i);
      }, 80);
    }, { passive: true });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-prev]')) { aller(courant() - 1); return; }
      if (e.target.closest('[data-carousel-next]')) { aller(courant() + 1); return; }
      var th = e.target.closest('[data-carousel-thumb]');
      if (th) aller(thumbs.indexOf(th));
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(courant() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); aller(courant() - 1); }
    });

    /* aller a une photo par son identifiant (fiche housse : photo du motif choisi) */
    root.carrouselVersImage = function (id) {
      var cle = String(id);
      for (var k = 0; k < n; k++) {
        if (slides[k].getAttribute('data-image-id') === cle) { if (k !== courant()) aller(k); return; }
      }
    };

    /* rotation du telephone ou fenetre redimensionnee : on reste sur la meme photo */
    window.addEventListener('resize', function () {
      track.scrollTo({ left: index * largeur(), behavior: 'auto' });
    });
  });

  /* ---- pages legales : un seul titre, le bon ----
     Shopify impose son propre titre (« Conditions d utilisation ») au-dessus du
     texte, qui commence deja par le sien (« Conditions Generales de Vente ») :
     deux titres, dont un faux. On garde celui du texte, en h1. */
  var titrePolitique = document.querySelector('.shopify-policy__title h1');
  var premierTitre = document.querySelector('.shopify-policy__body .rte > h2:first-child');
  if (titrePolitique && premierTitre) {
    titrePolitique.textContent = premierTitre.textContent;
    premierTitre.parentNode.removeChild(premierTitre);
  }

  /* ---- Guide des tailles en fenetre ----
     Tout lien vers /pages/guide-des-tailles ouvre la fenetre (layout) au lieu
     de quitter la page : le parent garde son choix de pack sous les yeux.
     Sur la page du guide elle-meme, le lien reste un lien. Echap ferme
     (natif de <dialog>), comme la croix, le bouton et un clic a cote. */
  var guide = document.querySelector('[data-guide-tailles]');
  if (guide && typeof guide.showModal === 'function') {
    var lienGuide = null;
    var fermerGuide = function () { if (guide.open) guide.close(); };
    guide.addEventListener('close', function () {
      document.documentElement.classList.remove('gt-ouvert');
      if (lienGuide) lienGuide.focus();
    });
    document.addEventListener('click', function (e) {
      var lien = e.target.closest('a[href]');
      if (lien && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        var chemin = new URL(lien.href, location.href).pathname.replace(/\/$/, '');
        if (chemin === '/pages/guide-des-tailles' && location.pathname.replace(/\/$/, '') !== chemin) {
          e.preventDefault();
          lienGuide = lien;
          guide.showModal();
          guide.scrollTop = 0;
          document.documentElement.classList.add('gt-ouvert');
          return;
        }
      }
      if (e.target.closest('[data-guide-fermer]')) { fermerGuide(); return; }
      /* clic sur le voile : la cible est la fenetre, mais hors de sa boite
         (un clic dans sa marge interieure vise aussi la fenetre) */
      if (e.target === guide) {
        var r = guide.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) fermerGuide();
      }
    });
  }

  /* ---- « Gerer mes cookies » (pied de page) ----
     Rouvre le bandeau de consentement de Shopify sur ses preferences. Si le
     bandeau n est pas disponible, le lien mene a la politique de cookies. */
  document.addEventListener('click', function (e) {
    var lien = e.target.closest('[data-cookie-prefs]');
    if (!lien || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    e.preventDefault();
    window.privacyBanner.showPreferences();
  });

  /* ---- retour en haut ---- */
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () {
      toTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- video en lecture auto : on respecte le choix du visiteur ----
     Par defaut la video tourne seule, en boucle, sans aucun bouton. Si les
     animations sont desactivees sur l appareil, on la met a l arret ET on
     affiche les commandes : sinon le visiteur n aurait aucun moyen de la lancer. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var videos = document.querySelectorAll('video[data-video-auto]');
    for (var v = 0; v < videos.length; v++) {
      videos[v].removeAttribute('autoplay');
      videos[v].setAttribute('controls', '');
      videos[v].pause();
    }
  }

  /* ---- video chargee a l approche (section Fabrication) ----
     L adresse attend dans data-src : la video ne se telecharge plus avec la
     page, seulement quand elle arrive a 600 px de l ecran. */
  var differees = Array.prototype.slice.call(document.querySelectorAll('video[data-src]'));
  /* Si le telephone refuse la lecture seule (mode economie d energie...), on
     affiche les commandes : sinon la video reste figee, sans moyen de la lancer. */
  function lancerVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var lecture = video.play();
    if (lecture && lecture.catch) {
      lecture.catch(function (erreur) {
        if (erreur && erreur.name === 'NotAllowedError') video.setAttribute('controls', '');
      });
    }
  }
  /* iPhone : la lecture seule ne part que si la video est a l ecran, pas a 600 px */
  function relancerSiVue(video) {
    if (video.dormilleVue && video.paused && !video.hasAttribute('controls')) lancerVideo(video);
  }
  var enVue = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.dormilleVue = e.isIntersecting;
          relancerSiVue(e.target);
        });
      }, { threshold: 0.25 })
    : null;
  /* un telephone met la video en pause quand on quitte l onglet ou la page :
     au retour, rien ne la relancait et elle restait figee */
  function relancerVideos() {
    if (document.hidden) return;
    Array.prototype.forEach.call(document.querySelectorAll('video[data-video-auto]'), relancerSiVue);
  }
  document.addEventListener('visibilitychange', relancerVideos);
  window.addEventListener('pageshow', relancerVideos);
  function chargerVideo(video) {
    if (!video.getAttribute('data-src')) return;
    video.src = video.getAttribute('data-src');
    video.removeAttribute('data-src');
    video.preload = 'auto';
    if (video.hasAttribute('autoplay')) {
      /* demarrage interrompu par un defilement rapide, ou arret impose par le
         telephone en cours de lecture : on repart aussitot */
      ['canplay', 'pause', 'ended', 'stalled'].forEach(function (evenement) {
        video.addEventListener(evenement, function () { relancerSiVue(video); });
      });
      if (enVue) enVue.observe(video);
      else lancerVideo(video);
      surveillerVideos();
    }
  }
  /* Filet de securite : chaque seconde, une video a l ecran doit avancer. Si elle
     reste figee sans etre en pause, on repart du debut, puis on la recharge. */
  var surveillance = null;
  function surveillerVideos() {
    if (surveillance) return;
    surveillance = setInterval(function () {
      if (document.hidden) return;
      Array.prototype.forEach.call(document.querySelectorAll('video[data-video-auto][src]'), function (video) {
        if (!video.dormilleVue || video.hasAttribute('controls')) return;
        if (video.paused) { lancerVideo(video); return; }
        if (video.currentTime !== video.dormilleTemps) {
          video.dormilleTemps = video.currentTime;
          video.dormilleFigee = 0;
          return;
        }
        video.dormilleFigee = (video.dormilleFigee || 0) + 1;
        if (video.dormilleFigee === 2) { video.currentTime = 0; video.dormilleTemps = 0; lancerVideo(video); }
        if (video.dormilleFigee === 4) { video.dormilleFigee = 0; video.load(); lancerVideo(video); }
      });
    }, 1000);
  }
  if (differees.length) {
    if ('IntersectionObserver' in window) {
      var guetteur = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { chargerVideo(e.target); guetteur.unobserve(e.target); }
        });
      }, { rootMargin: '600px 0px' });
      differees.forEach(function (video) { guetteur.observe(video); });
    } else {
      differees.forEach(chargerVideo);
    }
  }

  /* ---- barre d annonce defilante ----
     On mesure le lot de messages, on le clone jusqu a couvrir l ecran, puis on
     anime la piste d exactement une largeur de lot : la boucle ne se voit pas.
     Si l utilisateur a desactive les animations, on ne touche a rien. */
  /* une offre a date de fin disparait des que la date est passee, meme si la
     page vient d un cache (le Liquid la retire deja au rendu) */
  var finies = document.querySelectorAll('[data-annonce-fin]');
  for (var f = 0; f < finies.length; f++) {
    if (Date.now() / 1000 > parseInt(finies[f].getAttribute('data-annonce-fin'), 10)) {
      finies[f].parentNode.removeChild(finies[f]);
    }
  }
  var annonce = document.querySelector('[data-annonce]');
  if (annonce && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var piste = annonce.querySelector('[data-annonce-piste]');
    var lot = annonce.querySelector('[data-annonce-lot]');

    var prepararerAnnonce = function () {
      if (!piste || !lot) return;
      /* on repart d un seul lot pour mesurer sa vraie largeur */
      while (piste.children.length > 1) piste.removeChild(piste.lastChild);
      annonce.classList.remove('is-anime');
      var largeurLot = lot.getBoundingClientRect().width;
      var largeurBarre = annonce.getBoundingClientRect().width;
      if (largeurLot < 1 || largeurBarre < 1) return;

      var copies = Math.max(2, Math.ceil((largeurBarre * 2) / largeurLot) + 1);
      for (var i = 1; i < copies; i++) {
        var clone = lot.cloneNode(true);
        clone.removeAttribute('data-annonce-lot');
        clone.setAttribute('aria-hidden', 'true');
        /* les copies ne doivent pas se faire passer pour des blocs editables */
        var marques = clone.querySelectorAll('[data-shopify-editor-block]');
        for (var j = 0; j < marques.length; j++) marques[j].removeAttribute('data-shopify-editor-block');
        piste.appendChild(clone);
      }

      var vitesse = parseFloat(getComputedStyle(annonce).getPropertyValue('--annonce-vitesse')) || 45;
      annonce.style.setProperty('--annonce-lot', largeurLot + 'px');
      annonce.style.setProperty('--annonce-duree', (largeurLot / vitesse) + 's');
      annonce.classList.add('is-anime');
    };

    prepararerAnnonce();
    /* les polices arrivent apres : la largeur du lot change, on remesure */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(prepararerAnnonce);
    var minuteurAnnonce;
    window.addEventListener('resize', function () {
      clearTimeout(minuteurAnnonce);
      minuteurAnnonce = setTimeout(prepararerAnnonce, 200);
    });
  }
  /* ---- Fenetre de bienvenue (snippets/popup-bienvenue.liquid) ----
     S ouvre apres quelques secondes, une seule fois : la croix,
     Echap ou un clic a cote la font taire 14 jours ; une inscription, pour
     toujours. L envoi recharge la page (formulaire natif Shopify) : un drapeau
     de session dit que c est cette fenetre qui a ete envoyee, et non le
     formulaire du pied de page, pour rouvrir sur « Felicitations ». */
  var pb = document.querySelector('[data-popup-bienvenue]');
  if (pb && typeof pb.showModal === 'function') {
    var PB_CLE = 'dormille-bienvenue';
    var PB_ENVOI = 'dormille-bienvenue-envoi';
    var pbLire = function (zone, cle) { try { return window[zone].getItem(cle); } catch (e) { return null; } };
    var pbEcrire = function (zone, cle, val) {
      try { if (val === null) window[zone].removeItem(cle); else window[zone].setItem(cle, val); } catch (e) {}
    };
    var pbOffre = pb.querySelector('.pb-offre');
    var pbMerci = pb.querySelector('.pb-merci');
    var pbOuvrir = function () {
      if (pb.open) return;
      pb.showModal();
      document.documentElement.classList.add('pb-ouvert');
    };
    var pbFermer = function () { if (pb.open) pb.close(); };

    pb.addEventListener('close', function () {
      document.documentElement.classList.remove('pb-ouvert');
      if (pbLire('localStorage', PB_CLE) !== 'inscrit') pbEcrire('localStorage', PB_CLE, String(Date.now()));
    });
    pb.addEventListener('click', function (e) {
      if (e.target.closest('[data-pb-fermer]')) { pbFermer(); return; }
      if (e.target === pb) {
        var r = pb.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) pbFermer();
      }
    });
    pbOffre.addEventListener('submit', function () { pbEcrire('sessionStorage', PB_ENVOI, '1'); });

    var pbEnvoi = pbLire('sessionStorage', PB_ENVOI) === '1';
    pbEcrire('sessionStorage', PB_ENVOI, null);
    var pbUrl = new URL(location.href);
    var pbPoste = pbUrl.searchParams.get('customer_posted') === 'true';
    if (pbPoste) {
      /* inscrit, ici ou par le pied de page : on ne lui propose plus l offre */
      pbEcrire('localStorage', PB_CLE, 'inscrit');
      pbUrl.searchParams.delete('customer_posted');
      if (pbUrl.hash === '#popup-bienvenue-form') pbUrl.hash = '';
      history.replaceState(history.state, '', pbUrl.pathname + pbUrl.search + pbUrl.hash);
    }

    if (pbEnvoi && pbPoste) {
      pbOffre.hidden = true;
      pbMerci.hidden = false;
      pbOuvrir();
      pbMerci.querySelector('.pb-merci__titre').focus();
    } else if (pbEnvoi && pb.querySelector('[data-pb-erreur]')) {
      pbOuvrir();
    } else if (pbUrl.searchParams.has('fenetre-bienvenue')) {
      /* lien de test (?fenetre-bienvenue) : ouvre la fenetre sans tenir compte
         d un refus ou d une inscription deja memorises dans ce navigateur */
      setTimeout(pbOuvrir, 1000);
    } else {
      var pbEtat = pbLire('localStorage', PB_CLE);
      var pbRefusRecent = pbEtat && pbEtat !== 'inscrit' && (Date.now() - Number(pbEtat)) < 14 * 864e5;
      if (pbEtat !== 'inscrit' && !pbRefusRecent) {
        /* jamais par-dessus le panier ou le guide des tailles : on attend */
        var pbTenter = function () {
          if (document.querySelector('dialog[open], .dw-open')) { setTimeout(pbTenter, 4000); return; }
          pbOuvrir();
        };
        setTimeout(pbTenter, (parseFloat(pb.getAttribute('data-delai')) || 8) * 1000);
      }
    }
  }
})();
